module.exports = __webpack_public_path__ + "img/BAML-01.0d7bdf7a.png";